import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight, vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Gallery from '../../items/Gallery';

const IotmTable = ({ event, options }) => {
  const [showTable, setShowTable] = React.useState(false);
  const [showScen, setShowScen] = React.useState(false);
  const { t, i18n } = useTranslation();

  return (
    <div className='w-full'>
      <button
        onClick={() => setShowTable(!showTable)}
        class='btn btn-block btn-sm font-semibold text-xl inline-block align-middle bg-gray-50 hover:bg-blue-100'>
        {'...'}
      </button>

      {showTable && (
        <>
          <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 justify-items-center'>
            <table className='table text-gray-90 mx-6 my-1.5 w-full'>
              {/* head */}
              <thead>
                <tr className='text-gray-600 border'>
                  <th>Тип</th>
                  <th>ID</th>
                  <th>Карточка</th>
                  <th>Название</th>
                </tr>
              </thead>
              <tbody>
                {event.config && (
                  <>
                    {event.config.map((el, cIndex) => (
                      <>
                        <tr className='text-gray-600 text-xs sm:text-base md:text-base lg:text-base xl:text-base 2xl:text-base border break-words'>
                          <td class='p-1' key={cIndex + 1}>
                            <p class='line-clamp-1'>{el.subtype}</p>
                          </td>
                          <td class='p-1' key={cIndex + 2}>
                            <p class='line-clamp-1'>{el.id}</p>
                          </td>
                          <td class='p-1' key={cIndex + 3}>
                            <p class='line-clamp-1'>{el.page}</p>
                          </td>
                          <td class='p-1' key={cIndex + 4}>
                            <p class='line-clamp-1'>{el.descr}</p>
                          </td>
                        </tr>
                      </>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            <SyntaxHighlighter className='w-full m-6' language='basic' style={vs}>
              {event.scenario}
            </SyntaxHighlighter>
          </div>
        </>
      )}
    </div>
  );
};

export default IotmTable;
